import React, { FC } from 'react';

import { ContactUsButton } from 'src/common/components/contact-us/ContactUsButton';
import CloudStatusIcon from 'src/common/components/icons/CloudStatusIcon.svg?raw';
import { ProductType } from 'src/common/interfaces/Tenant';
import {
	DASHBOARD_ERROR_MSG,
	DASHBOARD_ERROR_TITLE
} from 'src/common/pages/dashboards-container/errorMessages';
import { LoadErrorMsgLayout } from 'src/common/pages/property/LoadErrorMsgLayout';

interface IErrorMessageProps {
	title: string;
	message: string;
	productType: ProductType;
	isNoData?: boolean;
}

export const MobileErrorMessage: FC<IErrorMessageProps> = ({
	title,
	message,
	productType,
	isNoData
}) => {
	if (isNoData) {
		return (
			<LoadErrorMsgLayout
				mainTitle={title}
				secondaryMsg={message}
				icon={CloudStatusIcon}
				className="mobile-error-message"
			>
				<ContactUsButton product={productType} />
			</LoadErrorMsgLayout>
		);
	}

	return (
		<LoadErrorMsgLayout
			mainTitle={DASHBOARD_ERROR_TITLE}
			secondaryMsg={DASHBOARD_ERROR_MSG}
			icon={CloudStatusIcon}
			className="mobile-error-message"
		>
			<ContactUsButton product={productType} />
		</LoadErrorMsgLayout>
	);
};
